
// Bootstrap JS for things like popup menus, modals, etc
require('bootstrap/dist/js/bootstrap.min.js');

// Select2 for the better dropdown controls
require('select2/dist/js/select2.full.min');
require('select2/dist/css/select2.min.css');
require('select2-bootstrap-theme/dist/select2-bootstrap.css');
